import { DropzoneProps } from "./types/dropzoneProps";
import { ReactComponent as uploadFileIcon } from '../../icons/upload_file.svg';
import { AdditionalIcon } from "../shared/additionalIcon/additionalIcon";
import { classNameBtn } from "../shared/button/types/buttonProps";
import { useId, useRef, useState } from "react";
// import ConfirmModal from "../modalWindow/confirmModal";
import ButtonField from "../buttonField/buttonField";
import { ButtonFieldProps } from "../buttonField/types/buttonFieldProps";
import { notifyWarn } from "../snackbar/snackbar";
import './dropzone.scss';

const Dropzone = (props: DropzoneProps) => {
    const [dragActive, setDragActive] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [isDropzoneFocusable, setIsDropzoneFocusable] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const refocusRef = useRef<HTMLDivElement>(null);
    const filesRef = useRef<File[]>([]);
    const dropzoneId = useId();

    // const refocus = () => {
    //     setIsDropzoneFocusable(true);
    //     refocusRef.current?.focus();
    // }
    
    const dropHandler = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        updateFiles(e.dataTransfer.files)
    }

    const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    }

    const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        updateFiles(e.target.files);
    }

    const updateFiles = (fileList: FileList | null) => {
        if (fileList && fileList.length > 0) {
            const newFiles = prepareFiles(fileList);
            if (isAllowed(newFiles)) {
                filesRef.current = newFiles;
                setConfirmation(true);
                confirm();
            } else {
                notifyWarn({ message: `Proszę wybrać plik ${props.acceptedFilesForSnackbar}` });
                clear();
            }
        } else {
            clear();
        }
    }

    const prepareFiles = (fileList: FileList) => {
        if (!props.multiple && fileList.length > 1) {
            return [fileList.item(0) as File];
        }
        return Array.from(fileList) as File[];
    }

    const isAllowed = (files: File[]) => {
        const acceptImages = props.acceptedFiles.includes("image/*");
        return files.every((file: File) => {
            if (acceptImages) {
                if (file.type.startsWith("image")) return true;
            }
            return props.acceptedFiles.includes(file.type);
        });
    }

    const clear = () => {
        filesRef.current = [];
        clearInput();
    }

    const clearInput = () => {
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    }

    const confirm = () => {
        setConfirmation(false);
        props.onConfirm(filesRef.current);
    }

    // const cancel = () => {
    //     setConfirmation(false);
    //     clear();
    // }

    const iconCss = {
        width: '100%',
        height: '48px'
    }

    const getBtnClass = () => {
        return `${classNameBtn.Btn} ${classNameBtn.Small} body-txt-medium uploadLabel`;
    }

    // const getQuestion = () => {
    //     const prefix = `Czy na pewno chcesz wgrać ${props.multiple ? "pliki" : "plik"}`;
    //     const fileNames = filesRef.current.map(f => { return `"${f.name}"` }).join(", ");
    //     return `${prefix} ${fileNames}?`;
    // }

    const onBtnClick = (e: any) => {
        e.preventDefault();
        clearInput();
        inputRef?.current?.click();
    };

    const getActionBtnProps = (title: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                disabled: props.disabled,
                className: getBtnClass()
            },
            placeHolder: title
        };
    }

    return (
        <div ref={refocusRef} tabIndex={isDropzoneFocusable ? 0 : -1} onBlur={() => { setIsDropzoneFocusable(false) }} className={props.hidden ? "" : "dropZone"} onDragEnter={handleDrag}>
            <input ref={inputRef} id={dropzoneId} multiple={props.multiple} type={"file"} onChange={inputHandler} accept={props.acceptedFiles.join(", ")} style={{ display: 'none' }}></input>
            {!props.hidden && <div>
                {AdditionalIcon(uploadFileIcon, iconCss)}
                <h4 style={{ textAlign: "center" }}>{props.dropzoneText}</h4>
            </div>}
            <label htmlFor={dropzoneId} className="uploadLabel">
                {props.children !== undefined
                    ? <div onClick={onBtnClick}>{props.children}</div>
                    : <ButtonField {...getActionBtnProps("Dodaj pliki", onBtnClick)} />
                }
            </label>
            {dragActive && !props.disabled && <div className="dropZoneArea" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={dropHandler}></div>}
            {props.disabled && <div className="dropZoneArea noDrop"></div>}
            {/* {confirmation && <ConfirmModal width={"660px"} height={"auto"}
                confirmTitle={"Tak, wgraj plik"}
                onConfirm={confirm}
                cancelTitle={"Anuluj"}
                onCancel={cancel}
                question={getQuestion()}
                refocus={refocus}
            />} */}
        </div>
    )
}

export default Dropzone;